import template from './owner-show.html';
import controller from './owner-show.controller';
import './owner-show.scss';

const ownerShowComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['$scope', '$rootScope', '$state', '$uibModal', 'notify', 'ownerService', 'userService'];

export default ownerShowComponent;
